import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "@/components/LoginPage.vue";
import SubmitSongs from "@/components/SubmitSongs.vue";
import VoteSongs from "./components/VoteSongs.vue";
import SongResults from "./components/SongResults.vue";

const routes = [
  { path: "/", component: LoginPage },
  { path: "/submit-songs", component: SubmitSongs },
  { path: "/vote-songs", component: VoteSongs },
  { path: "/song-results", component: SongResults }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router;